export default "__VITE_ASSET__Lzhg_fza__"